import Associates from "./Associates";
import CallToAction from "./CallToAction";
import { useNavigate } from "react-router-dom";

const NewServicePage = () => {
    const navigate = useNavigate();

    const loanData = [
        {
            title: "Audit & Assurance Services",
            description: "Ensuring Integrity, Transparency, and Compliance.",
            icon: "fa-search",
            link: "/audit-assurance-services-india",
        },
        {
            title: "Financial Hygiene & Managed Accounting",
            description: "Your Virtual Finance Back-Office.",
            icon: "fa-calculator",
            link: "/financial-hygiene-managed-accounting",
        },
        {
            title: <>Indian Tax Advisory <br /> (Direct & Indirect)</>,
            description: "Strategic Planning for the Modern Taxpayer.",
            icon: "fa-balance-scale",
            link: "/indian-tax-advisory",
        },
        {
            title: "Capital & Lending Solutions",
            description: "Fueling Business Growth through Smart Liquidity.",
            icon: "fa-money-bill-wave",
            link: "/loan-services-india",
        },
        {
            title: "Corporate Advisory & Virtual CFO ",
            description: "High-Level Strategic Solutions for Growing Enterprises",
            icon: "fa-briefcase",
            link: "/corporate-advisory-virtual-cfo",
        },
        {
            title: "Registration and Certifications",
            description: "Expert assistance in business registration and certifications",
            icon: "fa-certificate",
            link: "/registration-certifications",
        },
    ];

    return (
        <>
            <div className="other-pages-main-section service-page-fin">
                <h2 className="other-pages-title">Our Services</h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/loan-services-india")} style={{ cursor: "pointer" }}>Services</span>
                </p>
            </div>

            <Associates /> 

            <div className="loan-card-main">
                <h2 className="sections-title-smco">
                    <span className="horizontal-line"></span>Our Core Services
                </h2>
                <p className="sections-description-smco">
                    Quick approvals, low rates, and hassle-free loans tailored for you.
                </p>

                <div className="loan-cards-container-smco">
                    {loanData.map((loan, index) => (
                        <div
                            key={index}
                            className="loan-card-smco"
                            onClick={() => navigate(loan.link)}
                            style={{ cursor: "pointer" }}
                        >
                            <div className="loan-card-container-icon-dashed-border">
                                <div className="loan-card-icon-container-smco">
                                    <i className={`fa-solid ${loan.icon} loan-card-icon-smco`}></i>
                                </div>
                            </div>
                            <h3 className="loan-card-title-smco">{loan.title}</h3>
                            <p className="loan-card-description-smco">{loan.description}</p>

                            {/* Learn More Button */}
                            <button
                                className="loan-card-button-smco"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    navigate(loan.link);
                                }}
                            >
                                <i className="fa-solid fa-arrow-right learn-more-arrow"></i>
                            </button>
                        </div>
                    ))}
                </div>
            </div>

            <CallToAction />
        </>
    );
};

export default NewServicePage;
